import { MoneyScaled, removeScaleFromMoney } from '@quickbit/qb-design-system';

export const formatCurrency = (money: MoneyScaled) =>
  `${removeScaleFromMoney(money)} ${money.currencyCode}`;

export const prettyFormatCurrency = (money: MoneyScaled) => {
  const amount = removeScaleFromMoney(money);

  return new Intl.NumberFormat("en-US", {
    style: 'currency',
    currency: money.currencyCode,
  }).format(amount);
}
